export class Certificado {
    public EventoId: number;
    public EventoAno: number;
    public UsuarioId: number;
    public IsCna: boolean = false;
    public IsTrabalho: boolean = false;
    public TrabalhoId: number;
}


// WEBPACK FOOTER //
// ./src/models/cetificado.model.ts